import React from "react";

import { formatDate2 } from "../../utils/helpers";
import { IPromoCodeType } from "../../utils/types";
import Modal from "../Modal";

interface PropTypes {
  isVisible: boolean;
  onHide: () => void;
  promoCode: IPromoCodeType | null;
}

const ViewPromoCode = ({ isVisible, onHide, promoCode }: PropTypes) => {
  return (
    <Modal heading='Info' isVisible={isVisible} onHide={onHide}>
      <div className="w-full flex flex-col justify-center gap-4 h-full px-8">
        <p>
          <strong>Description: </strong>
          {promoCode?.description || "N/A"}
        </p>
        <p>
          <strong>Start date: </strong>
          {promoCode?.startDate ? formatDate2(promoCode.startDate) : "N/A"}
        </p>
        <p>
          <strong>Expiry date: </strong>
          {promoCode?.expiryDate ? formatDate2(promoCode.expiryDate) : "N/A"}
        </p>
        <p>
          <strong>Max users: </strong>
          {promoCode?.maxUsers || "N/A"}
        </p>
      </div>
    </Modal>
  );
};

export default ViewPromoCode;
